module.exports = __webpack_public_path__ + "static/media/arrow-circle-up.12bde415.svg";